import { ContactForm } from '@/components/common/ContactForm';
import { MotionReveal } from '@/components/common/MotionReveal';

export function ServicesContactSection() {
  return (
    <section className="border-t border-border bg-surface-muted py-18 sm:py-24 lg:py-30">
      <div className="site-container grid gap-10 lg:grid-cols-[0.8fr_1.2fr] lg:gap-16">
        <MotionReveal>
          <p className="section-label">Sledeći korak</p>
          <h2 className="mt-4 text-balance text-3xl font-semibold tracking-[-0.04em] text-text-primary sm:text-4xl">
            Potrebna vam je neka od naših usluga?
          </h2>
          <p className="mt-5 text-base leading-7 text-text-secondary sm:text-lg">
            Ostavite osnovne informacije o vašem cilju. Predložićemo format saradnje koji najbolje odgovara situaciji.
          </p>
        </MotionReveal>
        <MotionReveal delay={0.08}>
          <ContactForm variant="compact" />
        </MotionReveal>
      </div>
    </section>
  );
}
